function getDefaultState() {
  return {
    licenseeName: '',
    licenseeType: 'External'
  }
}
import axios from 'axios'
export default {
  namespaced: true,
  state: {
    licenseeName: '',
    licenseeType: 'External'
  },
  getters: {
    licenseeName(state) {
      return state.licenseeName
    },
    licenseeType(state) {
      return state.licenseeType
    }
  },
  mutations: {
    setLicensee(state, data) {
      state.licenseeName = data.name
      state.licenseeType = data.type
    },
    clearState(state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    async getLicensee({ commit }) {
      await axios
        .get('/licensees')
        .then((response) => {
          commit('setLicensee', response.data.data)
        })
        .catch((error) => {
          console.log('catch : error :' + error)
        })
    },
    clearState({ commit }) {
      commit('clearState')
    }
  }
}
